import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './pages/Sidebar/Sidebar';
import Header from './pages/Header/Header';
import Footer from './pages/Footer/Footer';
import './Layout.css';

const Layout = () => {
  return (
    <div className="layout-container">
      <Header />
      <div className="layout-body">
        <Sidebar />
        <main className="main-content">
          <Outlet />
        </main>
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
